import * as DataFormat from '../../../../Common/Scripts';

const AppointeeExceptionReasonsColumns = () => [
	{ dataField: 'rowId', text: 'Row ID', hidden: true, csvExport: false },
	{
		dataField: 'qualificationYear',
		text: 'Year',
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentType',
		text: 'Type',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markingTeamTitle',
		text: 'Marking Team Title',
		sort: true,
		headerClasses: 'th-title-td'
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'appointeeTitle',
		text: 'Title',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'initials',
		text: 'Initials',
		sort: true,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'surName',
		text: 'Surname',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'niNumber',
		text: 'NI Number',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markerCode',
		text: 'Marker Code',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'isPresentingSubject',
		text: 'Confirmation That Currently Presenting',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'retiralDate',
		text: 'Declaration of Interest If Retired Indicate Date of Retirement',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		formatter: cell => DataFormat.createTimeInput(cell),
		csvFormatter: cell => DataFormat.createTimeInput(cell)
	},
	{
		dataField: 'lastPresentedDate',
		text: 'Date Last Presented',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		formatter: cell => DataFormat.createTimeInput(cell),
		csvFormatter: cell => DataFormat.createTimeInput(cell)
	},
	{
		dataField: 'centreName',
		text: 'Centre Name',
		sort: true,
		headerClasses: 'th-title-td'
	},
	{
		dataField: 'exceptionCentreReason',
		text: 'Exception Reason',
		sort: true,
		headerClasses: 'th-title-td'
	},
	{ dataField: 'appointeeId', text: 'Appointee ID', hidden: true },
	{ dataField: 'appointmentId', text: 'Appointment ID', hidden: true }
];

export default AppointeeExceptionReasonsColumns;
